// extracted by mini-css-extract-plugin
module.exports = {"grand":"bottom_grand__5Jr_d","contact":"bottom_contact__1SOV_","bottom":"bottom_bottom__2cIer","bottom2":"bottom_bottom2__3hJZr","notReady":"bottom_notReady__2G_V9"};